export default __webpack_public_path__ + "static/japanese-fans-decf10151c88bab2c9893c5663f24d72.jpg";